<template>
  <div class="main--root">
    <p>
      Main Dashboard Page
    </p>
    <div class="ui grid">
      <div class="ten wide column">
        <div class="ui cards">
          <div class="card">
            <div class="content">
              <div class="ui statistic">
                <div class="value">
                  {{orgs.length}}
                </div>
                <div class="label">
                  Organization Profiles 
                </div>
              </div>
            </div>
            <div class="sc--btn--group">
              <router-link to="dashboard/orgs" class="sc--btn">
                View
              </router-link>
            </div>
          </div>
          <div class="card">
            <div class="content">
              <div class="ui statistic">
                <div class="value">
                  {{events.length}}
                </div>
                <div class="label">
                  Events
                </div>
              </div>
            </div>
            <div class="sc--btn--group">
              <router-link to="dashboard/events" class="sc--btn">
                View
              </router-link>
            </div>
          </div>
          <div class="card">
            <div class="content">
              <div class="ui statistic">
                <div class="value">
                  {{courses.length}}
                </div>
                <div class="label">
                  Courses
                </div>
              </div>
            </div>
            <div class="sc--btn--group">
              <router-link to="dashboard/courses" class="sc--btn">
                View
              </router-link>
            </div>
          </div>
        </div>

      </div>
      <div class="six wide column">
        <div class="ui feed">
          <h2>
            Recent Activity
          </h2>
          <div class="event">
            <div class="content">
              <div class="date">
                3 days ago
              </div>
              <div class="summary">
                You added a <a>resource name</a> to SCCU.
              </div>
            </div>
          </div>
          <div class="event">
              <div class="content">
                <div class="date">
                  3 days ago
                </div>
                <div class="summary">
                  You added a <a>resource name</a> to SCCU.
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="eight wide column">
        <div class="card">
          <div class="content">
            Some Data Here
          </div>
        </div>
      </div>
      <div class="eight wide column">
        <div class="card">
          <div class="content">
            <div class="content">
              Some Data Here
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainPage',
  data() {
    return {
      orgs: [],
      events: [],
      courses: [],
    };
  },
  created() {
    this.fetchOrgs();
    this.fetchEvents();
    this.fetchCourses();
  },
  methods: {
    async fetchOrgs() {
      try {
        const response = await fetch('/wp-json/custom/v1/my-org-profiles?k__sjnb__sdfjn0547=' + localStorage.getItem('sjdifjsckdsjfosdf54520zzz') + '', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        });

        const responseData = await response.json();

        if (response.ok && responseData.success) {
          this.orgs = responseData.orgs;
        } else {
          console.error('Failed to fetch orgs:', responseData);
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    },
    async fetchEvents() {
      try {
        const response = await fetch('/wp-json/custom/v1/my-events?k__sjnb__sdfjn0547=' + localStorage.getItem('sjdifjsckdsjfosdf54520zzz') + '', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        });

        const responseData = await response.json();

        if (response.ok && responseData.success) {
          this.events = responseData.events;
        } else {
          console.error('Failed to fetch events:', responseData);
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    },
    async fetchCourses() {
      try {
        const response = await fetch('/wp-json/custom/v1/my-trainings?k__sjnb__sdfjn0547=' + localStorage.getItem('sjdifjsckdsjfosdf54520zzz') + '', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        });

        const responseData = await response.json();

        if (response.ok && responseData.success) {
          this.courses = responseData.trainings;
        } else {
          console.error('Failed to fetch trainings:', responseData);
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    },
  },
}
</script>

<style lang="sass">
  .main--root
    .card
      padding: 40px !important

      .content
        display: flex
        justify-content: center
</style>